export const TOOLBAR_WIDTH_V2 = 56;
export const PANEL_WIDTH = 240;
export const CREDITS_INFO_WIDTH = 224;
export const DUPLICATE_NODE_OFFSET_X = 10;
export const PANEL_HEADER_HEIGHT = 72;
